export default __webpack_public_path__ + "static/media/c2.a85bdaa7.jpeg";